/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

const Youtube = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="22"
      fill="none"
      viewBox="0 0 32 22"
      className={className}
    >
      <path
        fill="#fff"
        d="M30.354 3.318A3.843 3.843 0 0027.613.634C25.195 0 15.5 0 15.5 0S5.806 0 3.389.634A3.843 3.843 0 00.648 3.318C0 5.686 0 10.626 0 10.626s0 4.94.648 7.307c.356 1.306 1.407 2.292 2.74 2.641 2.418.635 12.113.635 12.113.635s9.694 0 12.112-.635c1.334-.349 2.384-1.335 2.74-2.64.648-2.368.648-7.308.648-7.308s0-4.94-.647-7.308zM12.33 15.111V6.14l8.103 4.485-8.103 4.485z"
      ></path>
    </svg>
  )
}

Youtube.propTypes = {
  className: PropTypes.string,
}

export default Youtube
